import { createFileRoute } from '@tanstack/react-router';
import { AccessPage } from '@/features/access/page';
import { requirePermission } from '@/features/auth/access';
export const Route = createFileRoute('/_authenticated/system/roles')({
  beforeLoad: ({ context, location }) =>
    requirePermission(context.queryClient, location.href, 'roles:read'),
  component: () => <AccessPage kind="roles" />,
});
